import { Serializable } from "@/core/generated/api/decorators/serializable_decorator"
import { CandidateModel } from "@/modules/candidate/models/candidateModel"
import { SubAreaModel } from "@/modules/prices/models/subAreaModel"
import { UserModel } from "@/modules/users/models/userModel"
import { UserManagerModel } from "@/modules/users/models/userManagerModel"
import { ProposalBaseModel } from "../../models/proposalBaseModel"
import { TaskStatus } from "../../constants/taskStatus"
import { TaskKanbanStatus } from "../../core/constants/taskKanbanStatus"
import { HiringLocation } from "@/modules/tasks/models/rfs/hiringLocation"
import { UserListView } from "../../models/userListView"
import { CompanyListModel } from "@/modules/company/models/companyListModel"
import { EngagementType } from "../../active/constants/engagementType"
import { ServiceType } from "../../active/constants/serviceType"
import { RFQExtended } from "../../models/args/rfqExtended"

@Serializable
export class SupplierProposalModel extends ProposalBaseModel {
  interested: number = 0
  ownerName: string = ""
  ownerCustomerType: number = 0
  currency: string = ""
  mainTaskName: string = ""
  enableIntermediateSale: boolean = false
  languageRequired: string[] = []
  subAreas: SubAreaModel[] = []
  contacts: UserModel[] = []
  candidates: CandidateModel[] = []
  locations: HiringLocation[] = []
  leads: UserListView[] = []
  managers: UserManagerModel[] = []
  requester: UserModel | null = null

  entity: CompanyListModel | null = null
  serviceType: ServiceType = ServiceType.Consultant
  engagementType: EngagementType = EngagementType.TimeAndMaterial
  extended: RFQExtended | null = null
  isClosed: boolean = false
  accessDenied: boolean = false
  requestId: string = ""

  constructor(
    data: {
      uid: string
      name: string
      caseNumber: string
      description: string
      state: TaskStatus | ""
      kanbanStatus: TaskKanbanStatus
      internalDeadline: string
      maxNumberCandidates: number
      workplace: string
      startDate: string
      endDate: string
      isContinued: boolean
      interested: number
      intermediateSale: boolean
      acceptancePeriod: string
      customerId: string
      customerName: string
      extensionMonths: number
      version: number
      subtitle: string
      numHoursWeek: number
      engagementType: EngagementType
      ownerName: string
      ownerCustomerType: number
      currency: string
      mainTaskName: string
      enableIntermediateSale: boolean
      languageRequired: string[]
      files: any[]
      subAreas: any[]
      contacts: any[]
      candidates: any[]
      notes: any[]
      locations: any[]
      leads: UserListView[]
      managers: UserManagerModel[]
      requester: UserModel | null
      entity: CompanyListModel | null
      serviceType: ServiceType
      extended: RFQExtended | null
      isClosed: boolean
      accessDenied: boolean
      requestId: string
    } | null = null,
  ) {
    super(data)
    if (data) {
      this.interested = data.interested
      this.ownerName = data.ownerName
      this.ownerCustomerType = data.ownerCustomerType
      this.currency = data.currency
      this.mainTaskName = data.mainTaskName
      this.enableIntermediateSale = data.enableIntermediateSale
      this.languageRequired = data.languageRequired ?? []
      this.subAreas = data.subAreas || []
      this.contacts = data.contacts || []
      this.candidates = data.candidates || []
      this.locations = data.locations || []
      this.leads = data.leads || []
      this.managers = data.managers || []
      this.requester = data.requester || null
      this.entity = data.entity || null
      this.serviceType = data.serviceType || ServiceType.Consultant
      this.engagementType =
        data.engagementType ?? EngagementType.TimeAndMaterial
      this.extended = data.extended || null
      this.isClosed = data.isClosed || false
      this.accessDenied = data.accessDenied ?? false
      this.requestId = data.requestId ?? ""
    }
  }
}
